import React, { FC } from 'react';
import { Box, Card, Container, Flex } from '@radix-ui/themes';
import Badge from '../Badge/Badge';
import Statement from '../Statement/Statement';
import './Hero.css';

interface HeroProps { }

const Hero: FC<HeroProps> = () => (
  <Box className="Hero" data-testid="Hero">
    <Container size="4">
      <Card className="HeroWrapper" style={{ padding: '20px', borderRadius: '23px', background: '#10ddc270' }}>
        <Flex
          direction={{ initial: 'column', md: 'row' }}
          gap="8"
          align="center"
          justify="between"
        >
          <Box className="Hero-Statement">
            <Statement />
          </Box>
          <Box className="Hero-Badge">
            <Badge />
          </Box>
        </Flex>
      </Card>
    </Container>
  </Box>
);

export default Hero;
